import * as Sentry from '@sentry/react';
import Environment from '@/shared/util/environment';

export function initSentry() {
  // Only initialize Sentry in production and staging
  if (!Environment.isProduction() && !Environment.isStaging()) {
    return;
  }

  Sentry.init({
    release: CONFIG.DEPLOY.TAG || CONFIG.DEPLOY.SHA,
    environment: Environment.get(),
    dsn: 'https://a5617c4d9c0d3e2d934039316813a12b@o4506389234712576.ingest.sentry.io/4506389286486016',
    // Reduce error volume
    sampleRate: 0.25, // Only send 25% of errors

    // Ignore common browser errors
    ignoreErrors: [
      'ResizeObserver loop limit exceeded',
      'Non-Error promise rejection',
      'ChunkLoadError',
      'Loading chunk',
      /^NetworkError/,
      /Script error/i, // Generic browser script errors (CORS, etc.)
    ],

    // Ignore errors from browser extensions
    denyUrls: [
      /extensions\//i,
      /^chrome:\/\//i,
      /^chrome-extension:\/\//i,
    ],

    // Reduce breadcrumbs
    maxBreadcrumbs: 50,
  });
}
